import { apiClient } from "@/lib/api";
import type { StandardResponse } from "@/types/api-response";
import { extractData } from "@/types/api-response";
import type {
  RegistrarSettingsDto,
  RegistrarConnectivityResultDto,
} from "@/types/domain";

/**
 * Admin Registrar Service
 *
 * Read-only access to the active registrar provider configuration
 * and its connectivity status, plus an on-demand connectivity test.
 *
 * Routes:
 *   GET  /api/v1/registrar-admin/settings
 *   POST /api/v1/registrar-admin/connectivity-test
 */
export const adminRegistrarService = {
  /**
   * Get the active registrar provider, its non-secret configuration,
   * and the latest connectivity indicator.
   */
  async getSettings(): Promise<RegistrarSettingsDto> {
    const response = await apiClient.get<
      StandardResponse<RegistrarSettingsDto>
    >("/api/v1/registrar-admin/settings");
    return extractData(response.data);
  },

  /**
   * Run an on-demand registrar connectivity test.
   *
   * Probes the active registrar and returns the result immediately.
   */
  async testConnectivity(): Promise<RegistrarConnectivityResultDto> {
    const response = await apiClient.post<
      StandardResponse<RegistrarConnectivityResultDto>
    >("/api/v1/registrar-admin/connectivity-test");
    return extractData(response.data);
  },
};
